import React from "react"
import { toast } from "react-toastify"

const authUri = process.env.REACT_APP_AUTH_URL
const apiUri = process.env.REACT_APP_API_URL
const clientUri = process.env.REACT_APP_CLIENT_URL
export const Config = {
  authority: authUri,
  client_id: "transfersSPA",
  client_secret: "SuperSecretPassword",
  redirect_uri: `${clientUri}/callback`,
  response_type: "id_token token",
  scope: "openid profile email api.user api.admin",
  post_logout_redirect_uri: clientUri,
  dataApi: `${apiUri}/api/data`,
  reportApi: `${apiUri}/api/report`,
  checkApi: `${apiUri}/api/check`,
  automaticSilentRenew: true
}

class AuthenticationCallback extends React.Component {
  componentDidMount() {
    const { UserManager } = this.props
    UserManager.signinRedirectCallback()
      .then(() => window.location.replace("/"))
      .catch((error) => toast.error(error))
  }
  render() {
    return <div />
  }
}

export default AuthenticationCallback
